import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledTranslationPopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 30vw;
  color: ${Colors.textDark};

  .word {
    font-size: 30px;
    text-decoration: underline;
  }

  .translation {
    font-size: 25px;
  }

  @media only screen and (max-height: 500px) and (orientation: landscape) {
    .word {
      font-size: 18px;
      text-decoration: underline;
    }

    .translation {
      font-size: 18px;
    }
  }
`;
